<template>
  <v-container>
    <div class="d-flex justify-space-between">
      <div class="office-title">ตั้งค่า</div>
      <Breadcrumbs :items="breadcrumbs" />
    </div>
    <v-card>
      <v-tabs right show-arrows>
        <v-tab
          v-for="(tab, index) in tabs"
          :key="index"
          :to="{ name: tab.link }"
          right
          dark
        >
          <v-badge
            :color="tab.badge ? 'danger' : 'transparent'"
            :content="tab.badge"
          >
            <v-icon left>{{ tab.icon }}</v-icon>
            {{ tab.title }}
          </v-badge>
        </v-tab>
      </v-tabs>
      <v-card-text>
        <router-view></router-view>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumbs from "@/components/breadcrumbs/Breadcrumbs"

export default {
  name: "SettingLayout",
  components: {
    Breadcrumbs,
  },
  data() {
    return {
      tabs: [
        {
          title: "ตั้งค่า",
          icon: "fa-cog",
          link: "OfficeSetting",
          badge: 0,
        },
      ],
    }
  },
  computed: {
    ...mapGetters(["breadcrumbs"]),
  },
}
</script>